import React, { useState } from 'lib/react';
import {
  EVGrid, EVTypography,
} from 'lib/components';
import TextInputField from 'commonComponents/textInputField';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import { EMAIL_REGEX } from 'constants/AppConstants';
import { getPropertyValues } from 'features/orderPreferences/OrderPreferences.utils';
import MaskedPhoneNumber from 'commonComponents/maskedPhoneNumber';
import CustomCoverStyles from '../CustomCoverStyles';

function ContactInformation({ orderPreferences, inputFieldValues, handlePropertyChange }) {
  const classes = CustomCoverStyles();
  const { t } = useTranslation();

  const isAdmin = orderPreferences?.isAdmin;
  const [emailError, setEmailError] = useState(false);

  const handleChange = ({ target: { id, value } }) => {
    if (id === 'reportOptionsCoverCompanyEmail') {
      const isValidEmail = EMAIL_REGEX.test(value);
      setEmailError(!isValidEmail);
    }
    handlePropertyChange(id, 'value', value);
  };

  return (
    <EVGrid className={classes.coverPageInformationContainer}>
      <EVTypography className={classes.coverPageInformationTextStyles}>
        {t('ContactInformation')}
      </EVTypography>
      <EVGrid
        container
        direction="column"
        style={{ display: 'flex', gap: '24px' }}
        component="form"
      >
        <EVGrid
          item
          className={classes.inputFieldContainer}
        >
          <TextInputField
            handleChange={handleChange}
            inputId="reportOptionsCoverContactName"
            inputValue={getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverContactName')?.value}
            inputLabelProps={{ className: classes.coverPageInputLabels }}
            labelText={t('order_preferences__custom_cover_contact_name')}
            inputFieldProps={{
              disabled: !isAdmin && !orderPreferences.reportOptionsCoverContactName?.canEdit,
              InputProps: { classes: { root: classes.inputTextField } },
            }}
          />
        </EVGrid>
        <EVGrid className={classes.coverPageTitleSubtitleContainer}>
          <EVGrid className={classes.inputFieldContainer}>
            <TextInputField
              handleChange={handleChange}
              inputId="reportOptionsCoverContactPhone"
              inputValue={getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverContactPhone')?.value}
              inputLabelProps={{ className: classes.coverPageInputLabels }}
              labelText={t('order_preferences__custom_cover_contact_phone')}
              inputFieldProps={{
                inputProps: { maxLength: 12 },
                disabled: !isAdmin && !orderPreferences.reportOptionsCoverContactPhone?.canEdit,
                classes: { root: classes.inputTextField },
              }}
              InputProps={{
                inputComponent: MaskedPhoneNumber,
              }}
            />
          </EVGrid>
          <EVGrid className={classes.inputFieldContainer}>
            <TextInputField
              handleChange={handleChange}
              inputId="reportOptionsCoverCompanyEmail"
              inputValue={getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyEmail')?.value}
              inputLabelProps={{ className: classes.coverPageInputLabels }}
              labelText={t('order_preferences__custom_cover_contact_email')}
              inputFieldProps={{
                disabled: !isAdmin && !orderPreferences.reportOptionsCoverCompanyEmail?.canEdit,
                InputProps: { classes: { root: classes.inputTextField } },
                FormHelperTextProps: { classes: { error: classes.errorHelperText } },
              }}
              helperText={emailError && t('finalize_order__invalid_email_address')}
            />
          </EVGrid>
        </EVGrid>
        <EVGrid
          item
          className={classes.inputFieldContainer}
        >
          <TextInputField
            handleChange={handleChange}
            inputId="reportOptionsCoverCompanyURL"
            inputValue={getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyURL')?.value}
            inputLabelProps={{ className: classes.coverPageInputLabels }}
            labelText={t('order_preferences__custom_cover_website_url')}
            inputFieldProps={{
              disabled: !isAdmin && !orderPreferences.reportOptionsCoverCompanyURL?.canEdit,
              InputProps: { classes: { root: classes.inputTextField } },
            }}
          />
        </EVGrid>
      </EVGrid>
    </EVGrid>
  );
}

ContactInformation.propTypes = {
  handlePropertyChange: PropTypes.func.isRequired,
  orderPreferences: PropTypes.shape().isRequired,
  inputFieldValues: PropTypes.shape().isRequired,
};

export default ContactInformation;
